import React from "react";
import { RouteComponentProps } from "react-router";
import { IonContent, IonPage } from "@ionic/react";
import { HelpoHeader } from "../components/shared/HelpoHeader";
import { ChallengeList } from "../components/challenges/ChallengeList";

interface ThemesPageProps extends RouteComponentProps<{ id: string }> {}

export const ThemesPage: React.FC<ThemesPageProps> = ({ match }) => {
  const theme = match.params.id;

  return (
    <IonPage>
      <HelpoHeader title={theme} />
      <IonContent>
        <ChallengeList theme={theme} />
      </IonContent>
    </IonPage>
  );
};
